var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0100098,
    y: 0.5,
    width: 47.99,
    height: 47.99,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9734 33.4913V31.4921C27.9734 30.4317 27.5522 29.4147 26.8023 28.6649C26.0525 27.915 25.0355 27.4938 23.9751 27.4938H17.9776C16.9172 27.4938 15.9002 27.915 15.1503 28.6649C14.4005 29.4147 13.9792 30.4317 13.9792 31.4921V33.4913",
    stroke: "#16A34A",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9761 23.4954C23.1843 23.4954 24.9745 21.7053 24.9745 19.4971C24.9745 17.2889 23.1843 15.4988 20.9761 15.4988C18.7679 15.4988 16.9778 17.2889 16.9778 19.4971C16.9778 21.7053 18.7679 23.4954 20.9761 23.4954Z",
    stroke: "#16A34A",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9713 33.492V31.4925C33.9706 30.6065 33.6757 29.7458 33.1329 29.0456C32.5901 28.3453 31.8301 27.8452 30.9722 27.6237",
    stroke: "#16A34A",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9734 15.6287C28.8334 15.8489 29.5957 16.3491 30.1401 17.0504C30.6845 17.7517 30.98 18.6142 30.98 19.502C30.98 20.3898 30.6845 21.2524 30.1401 21.9537C29.5957 22.655 28.8334 23.1552 27.9734 23.3754",
    stroke: "#16A34A",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.5cd295968de1c7084478397daa150953.svg";
export { ForwardRef as ReactComponent };